"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDirectDebitDateLegacyMutation = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_query_1 = require("react-query");
var core_1 = require("../../../core");
var cache_key_1 = require("./cache-key");
function useDirectDebitDateLegacyMutation(accountId, onSuccess) {
    var api = core_1.configService.getConfig().api;
    var directDebitDateEndpoint = "".concat(api.baseUrl, "/pace/payments/v1/").concat(accountId, "/direct-debit/date");
    var queryClient = (0, react_query_1.useQueryClient)();
    return (0, ui_tools_1.useReactMutation)(function (_a) {
        var dayOfMonth = _a.dayOfMonth;
        return core_1.apiService
            .put({
            responseType: 'json',
            url: directDebitDateEndpoint,
            body: { dayOfMonth: dayOfMonth },
        })
            .then(function (data) {
            var oldData = queryClient.getQueryData((0, cache_key_1.cacheKey)(accountId));
            // Manually update cache to avoid async platform issues.
            oldData &&
                queryClient.setQueryData((0, cache_key_1.cacheKey)(accountId), __assign(__assign({}, oldData), { dayOfMonth: dayOfMonth }));
            return data;
        });
    }, {
        onSuccess: function (_a) {
            var nextPaymentChargeDate = _a.nextPaymentChargeDate;
            if (onSuccess) {
                onSuccess(nextPaymentChargeDate);
            }
        },
    });
}
exports.useDirectDebitDateLegacyMutation = useDirectDebitDateLegacyMutation;
